<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="tertiary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Orden {{orden.folio}}</ion-title>
      <ion-buttons slot="end">
        <ion-button v-if="!editable" @click="toggleEditar" size="small">
          <i class="icon ion-ios-create icon-sm"></i>&nbsp;Editar
        </ion-button>
        <ion-button v-else @click="editable=!editable">
          <i class="icon ion-ios-checkmark-circle-outline"></i>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-row>
      <ion-col class="ion-no-padding" v-for="n in navbarMenu" :key="n.modo">
        <ion-item lines="none" :color="(modo==n.modo)?'tertiary':'secondary'" class="ordennavbar" @click="setModo(n.modo)">
          <ion-label class="ion-text-center">
            <h2>
              <i :class="'icon icon-s ion-ios-'+n.icono"></i>
            </h2>
            <p style="font-size:0.60em;">{{n.label}}</p>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-progress-bar v-if="cargando" type="indeterminate" color="warning"></ion-progress-bar>
    <ion-progress-bar v-if="cargando" type="indeterminate" color="warning"></ion-progress-bar>
  </ion-header>
  <ion-content color="">
    <TarjetaEquipo :id="orden.idEquipo" v-if="orden.idEquipo && orden.idEquipo!='' && modo!='acciones'" />
    <div v-if="modo=='general'">
      <ion-card>
        <ion-item color="tertiary" lines="none" v-if="orden.folio">
          <ion-label>Folio</ion-label>
          <ion-input readonly class="ion-text-right" color="danger" :value="orden.folio"></ion-input>
        </ion-item>
        <ion-row class="ion-padding">
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6">
            <ion-item>
              <ion-label position="stacked">Fecha creada</ion-label>
              <ion-input :readonly="!editable" debounce="500" type="datetime-local" color="primary" :value="orden.fechaCreada | moment('YYYY-MM-DDTHH:mm')" v-on:ionChange="set('fechaCreada',new Date($event.detail.value).getTime())"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6">
            <ion-row>
              <ion-col class="ion-no-padding" size="10">
                <ion-item @click="seleccionarCliente">
                  <ion-label position="stacked">Cliente</ion-label>
                  <ion-input readonly color="primary" :value="(orden.cliente||{}).nombre || '(Sin cliente)'" />
                </ion-item>
              </ion-col>
              <ion-col class="ion-no-padding" size="2">
                <ion-item lines="none" @click="nuevoCliente">
                  <ion-label class="ion-text-right" color="secondary">
                    <p>.</p>
                    <p>&nbsp;</p>
                    <h1><i class="icon ion-ios-add-circle-outline"></i></h1>
                  </ion-label>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding" v-if="proyectos.length>0">
            <ion-item>
              <ion-label position="stacked">Proyecto</ion-label>
              <ion-select :disabled="!editable" :value="orden.idProyecto" v-on:ionChange="orden.idProyecto=$event.detail.value">
                <ion-select-option :value="''">(Sin proyecto)</ion-select-option>
                <ion-select-option v-for="p in proyectos" :key="p._id" :value="p._id">{{p.nombre}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6">
            <ion-row>
              <ion-col class="ion-no-padding">
                <ion-item>
                  <ion-label position="stacked">Branding</ion-label>
                  <ion-select :disabled="!editable" :value="orden.idBranding" v-on:ionChange="set('idBranding',$event.detail.value)">
                    <ion-select-option :value="''">Seleccione...</ion-select-option>
                    <ion-select-option v-for="c in brandings" :key="c._id" :value="c._id">{{c.alias || c.nombre}}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6" v-if="!ocultarCampoEquipo">
            <ion-row>
              <ion-col class="ion-no-padding" :size="(orden.idCliente!='' && editable)?10:12">
                <ion-item @click="seleccionarEquipo">
                  <ion-label position="stacked">Equipo</ion-label>
                  <ion-input :color="editable?'primary':'medium'" :value="nombreDelEquipo()" readonly />
                </ion-item>
              </ion-col>
              <ion-col class="ion-no-padding" :size="2" v-if="orden.idCliente && editable">
                <ion-item lines="none" @click="nuevoEquipo">
                  <ion-label class="ion-text-right" color="secondary">
                    <p>.</p>
                    <p>&nbsp;</p>
                    <h1><i class="icon ion-ios-add-circle-outline"></i></h1>
                  </ion-label>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6">
            <ion-row>
              <ion-col class="ion-no-padding">
                <ion-item>
                  <ion-label position="stacked">Tipo de orden de servicio</ion-label>
                  <ion-select :disabled="!editable" :value="orden.tipoOrdenServicio" v-on:ionChange="set('tipoOrdenServicio',$event.detail.value)">
                    <ion-select-option :value="''">Seleccione...</ion-select-option>
                    <ion-select-option v-for="c in tiposOrdenesServicio" :key="c" :value="c">{{c}}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="6">
            <ion-row>
              <ion-col class="ion-no-padding">
                <ion-item>
                  <ion-label position="stacked">Solicitante</ion-label>
                  <ion-input :disabled="!editable" class="ion-text-left" color="primary" :value="orden.solicitante" v-on:ionChange="set('solicitante',$event.detail.value)"></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding" size-xs="12" size-sm="12" v-if="(yo.rol=='administrador' || yo.permiso_asignarOrdenesServicio)&&usuarios.length>0">
            <ion-row>
              <ion-col class="ion-no-padding">
                <ion-item>
                  <ion-label position="stacked">Usuario asignado</ion-label>
                  <ion-select :value="orden.idAutor" v-on:ionChange="orden.idAutor=$event.detail.value" :disabled="!editable">
                    <ion-select-option v-if="orden.idAutor && !usuarioExiste(orden.idAutor)" :value="orden.idAutor">(Usuario eliminado)</ion-select-option>
                    <ion-select-option v-for="u in usuarios" :key="u._id" :value="u._id">{{u.nombre}}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-card>
      <ion-row v-if="orden.terminada && empresa.medirTiemposDeOrdenes">
        <ion-col class="ion-padding">
          <ion-item>
            <ion-label position="stacked">Fecha terminada</ion-label>
            <ion-input readonly type="date" color="primary" :value="orden.fechaTerminada | moment('YYYY-MM-DD')"></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
    </div>
    <div v-if="modo=='diagnostico'">
      <ion-row>
        <ion-col v-for="s in soap" class="ion-padding" :key="s.name" size="12" size-sm="6">
          <ion-item>
            <ion-label position="stacked">{{s.label}}</ion-label>
            <ion-textarea :readonly="!editable" :value="orden[s.name]" v-on:ionChange="set(s.name,$event.detail.value)" rows="3"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col class="ion-padding" size="12" size-sm="6">
          <ion-item>
            <ion-label position="floating">Tipo de incidente</ion-label>
            <ion-select :value="orden.tiposIncidente" v-on:ionChange="set('tiposIncidente',$event.detail.value)" :disabled="!editable">
              <ion-select-option v-for="i in tiposIncidentes" :key="i" :value="i">{{i}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col class="ion-padding" size="12" size-sm="6">
          <ion-item>
            <ion-label>Incidente resuelto</ion-label>
            <ion-toggle slot="end" :disabled="!editable" color="medium" :checked="orden.terminada==true" v-on:ionChange="set('terminada',$event.detail.checked==true)" />
          </ion-item>
        </ion-col>
        <ion-col class="ion-padding" size="12">
          <ion-item lines="none" color="light" class="ion-no-padding">
            <ion-label>&nbsp;</ion-label>
          </ion-item>
          <ion-item lines="none" color="light" class="ion-no-padding">
            <ion-label>&nbsp;</ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </div>
    <div v-if="modo=='evidencias'">
      <ion-list>
        <ion-item-sliding v-for="(i,indice) in orden.imagenes" :key="i.imagen">
          <ion-item>
            <ion-thumbnail slot="start" v-if="i.imagen">
              <ion-img :src="cdn+i.imagen"></ion-img>
            </ion-thumbnail>
            <ion-label>
              <h2>{{i.imagen}}</h2>
              <p>{{i.descripcion}}</p>
            </ion-label>
          </ion-item>
          <ion-item-options slot="end">
            <ion-item-option v-on:click="eliminarImagen(indice)" color="danger" v-if="orden.idAutor==yo._id || yo.rol=='administrador'">
              <i class="icon ion-ios-trash"></i>
            </ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-list>
    </div>
    <div v-if="modo=='costos'">
      <ion-list>
        <ion-item lines="none">
          <ion-label color="danger">Refacciones y costos</ion-label>
          <ion-button slot="end" fill="clear" color="danger" :disabled="!editable" @click="agregarCosto">
            <i class="icon ion-ios-add-circle"></i>
          </ion-button>
        </ion-item>
        <ion-row v-for="(costo,indice) in orden.costos" :key="indice">
          <ion-col class="ion-no-padding" size="2">
            <ion-item>
              <ion-label position="floating" v-if="(costo.cantidad||0)!=0">Cant.</ion-label>
              <ion-label position="floating" v-else color="danger">Eliminar</ion-label>
              <ion-input type="number" step="any" min="0" v-on:ionChange="costo.cantidad=parseFloat($event.detail.value)" :value="costo.cantidad" :readonly="!editable"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col class="ion-no-padding" :size="empresa.calcularCostos?5:10">
            <ion-item>
              <ion-label position="floating">Refacción o costo</ion-label>
              <ion-input :value="costo.concepto" v-on:ionChange="costo.concepto=$event.detail.value" :readonly="!editable"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col class="ion-no-padding" size="3" v-if="empresa.calcularCostos">
            <ion-item>
              <ion-label position="floating">P.U.</ion-label>
              <ion-input type="number" step="any" min="0" :value="costo.precioUnitario" v-on:ionChange="costo.precioUnitario=parseFloat($event.detail.value)" :readonly="!editable"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col class="ion-no-padding" size="2" v-if="empresa.calcularCostos">
            <ion-item>
              <ion-label position="floating">Importe</ion-label>
              <ion-input disabled :value="costo.precioUnitario*costo.cantidad" type="number"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-list>
    </div>
    <div v-if="modo=='acciones'">
      <ion-row>
        <ion-col :size-md="pdfUrl?4:12" size-xs="12">
          <ion-row>
            <ion-col size-xs="12" size-sm="6" v-for="a in accionesFiltradas" :key="a.label">
              <ion-card>
                <ion-item lines="none" color="" @click="accion(a.label)">
                  <ion-label class="ion-text-center" :color="a.color || 'secondary'" text-wrap>
                    <h1>
                      <i :class="'icon icon-xl ion-ios-'+a.icon"></i>
                    </h1>
                    <p>{{a.label}}</p>
                  </ion-label>
                </ion-item>
              </ion-card>
            </ion-col>
            <ion-col size="12" v-if="yo.rol=='administrador'">
              <ion-list v-if="eventos.length>0">
                <ion-item>
                  <ion-label color="medium">
                    <p>Bitácora de eventos</p>
                  </ion-label>
                </ion-item>
                <ion-item v-for="i in eventos" :key="i._id">
                  <ion-label text-wrap>
                    <h2>{{i.mensaje}}</h2>
                    <p>{{i.autor ? i.autor.nombre : '(Usuario eliminado)'}}</p>
                  </ion-label>
                  <ion-note slot="end">{{i.fecha | moment('MMM DD HH:mm')}}</ion-note>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col v-if="pdfUrl" size-md="8" size-xs="12">
          <embed class="pdfembed" :src="pdfUrl" type="application/pdf" :download="(orden.nombre || orden.folio || orden._id)+'.pdf'" />
        </ion-col>
      </ion-row>
    </div>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed" v-if="['general','diagnostico','costos'].indexOf(modo)>=0">
      <ion-fab-button color="warning" @click="guardar" v-if="editable" :disabled="cargando">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
      <ion-fab-button color="secondary" @click="volver" v-else>
        <i class="icon icon-lg ion-ios-checkmark"></i>
      </ion-fab-button>
    </ion-fab>
    <label for="img" v-if="modo=='evidencias'">
      <input class="hidden" id="img" name="img" type="file" @change="subirImagen">
      <ion-fab horizontal="end" vertical="bottom" slot="fixed">
        <ion-fab-button color="warning" :disabled="!editable || cargando">
          <i class="icon icon-lg ion-ios-camera"></i>
        </ion-fab-button>
      </ion-fab>
    </label>
  </ion-content>
</ion-app>
</template>
<style>
.ordennavbar p {
  font-size: 0.65em;
}

.pdfembed {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>
<script>
import Api from '@/components/Api/Api'
import Docxgen from '@/models/Docxgen'
import TarjetaEquipo from '@/components/TarjetaEquipo'
import CatalogoCliente from '@/components/Catalogos/Cliente'
import CatalogoEquipo from '@/components/Catalogos/Equipo'
import ModalSeleccionarEquipo from '@/components/ModalSeleccionarEquipo'
import ModalSeleccionarCliente from '@/components/ModalSeleccionarCliente'
import modalCitaTentativa from '@/components/Agenda/Cita'
import Emailer from '@/models/Emailer'
//import SelectorEquipo from '@/components/SelectorEquipo'
export default {
  name: 'Orden',
  components: {
    TarjetaEquipo,
    //SelectorEquipo
  },
  props: {
    id: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      esMovil: Api.esMovil(),
      cdn: Api.cdn + '/',
      editable: false,
      cargando: true,
      modo: 'general',
      pdfUrl: null,
      ocultarCampoEquipo: false,
      empresa: {},
      brandings: [],
      usuarios: [],
      proyectos: [],
      orden: {
        idProyecto: '',
        fechaCreada: new Date().getTime(), //.toISOString().substring(0, 10),
        fecha: new Date().getTime(),
        idAutor: (Api.fetchLocal('cmms.yo') || {})._id,
        idCliente: '',
        idEquipo: '',
        terminada: false,
        tiposIncidente: 'Otros',
        tipoOrdenServicio: 'Diagnóstico',
        costos: []
      },
      custodias: [],
      navbarMenu: [{
        label: 'General',
        modo: 'general',
        icono: 'home'
      }, {
        label: 'Diagnóstico',
        modo: 'diagnostico',
        icono: 'hammer'
      }, {
        label: 'Evidencias',
        modo: 'evidencias',
        icono: 'images'
      }, {
        label: 'Refacciones',
        modo: 'costos',
        icono: 'pricetags'
      }, {
        label: 'Más',
        modo: 'acciones',
        icono: 'more'
      }],
      tiposOrdenesServicio: ['Garantía', 'Preventivo', 'Correctivo', 'Diagnóstico', 'Reparación', 'Capacitación', 'Instalación', 'Otros'],
      tiposIncidentes: ['Sin incidente', 'Error de usuario', 'Daño accidental', 'Fallo de componentes', 'Accesorios en mal estado', 'Consumibles en mal estado', 'Consumible agotado', 'Otros'],
      campos: [{
        label: 'Cliente',
        type: 'select',
        name: 'idCliente',
        options: [1, 2, 3, 4],
        buttonAction: 'nuevoCliente'
      }, {
        label: 'Branding',
        type: 'select',
        name: 'idBranding',
        options: ['Tecnhos', 'Ingeniería Hospitalaria']
      }, {
        label: 'Tipo de orden de servicio',
        type: 'select',
        name: 'tipoOrdenServicio',
        options: []
      }, {
        label: 'Equipo a revisar',
        type: 'select',
        name: 'idEquipo',
        options: [1, 2, 3, 4],
        buttonAction: 'nuevoEquipo'
        //  buttonAction:''
      }, {
        label: 'Solicitante',
        name: 'solicitante',
        type: 'text',
      }],
      soap: [{
          label: 'Falla reportada',
          name: 'fallaReportada'
        },
        {
          label: 'Falla encontrada',
          name: 'fallaEncontrada'
        },
        {
          label: 'Diagnóstico (Reporte técnico)',
          name: 'diagnostico',
        },
        {
          label: 'Plan de acción (Notas)',
          name: 'planDeAccion'
        },
        {
          label: 'Condiciones de recepción de equipo',
          name: 'condicionesRecepcion'
        },
        {
          label: 'Condiciones de entrega',
          name: 'condicionesEntrega'
        }
      ],
      acciones: [{
        label: 'PDF',
        icon: 'document',
        color: 'primary'
      }, {
        label: 'Enviar',
        icon: 'paper-plane',
        color: 'secondary'
      }, {
        label: 'Historial de equipo',
        icon: 'cog',
        color: 'secondary'
      }, {
        label: 'Custodia',
        icon: 'link',
        color: 'tertiary'
      }, {
        label: 'Cita tentativa',
        icon: 'clock',
        color: 'warning'
      }, {
        label: 'Cancelar',
        icon: 'remove-circle-outline',
        color: 'danger',
        ocultar: (Api.fetchLocal('cmms.yo') || {}).rol != 'administrador'
      }],
      eventos: [],
      modals: [],
      reintentosPDF: 2
    }
  },
  computed: {
    accionesFiltradas() {
      return this.acciones.filter(a => !a.ocultar)
    }
  },
  async mounted() {
    try {
      await this.inicializar()
    } catch (e) {
      await Api.wait(500)
    }
    this.inicializar()
  },
  methods: {
    usuarioExiste(idAutor) {
      if (!idAutor || !this.usuarios) return false
      return this.usuarios.some(u => u._id === idAutor)
    },
    openEnd() {
      Api.$emit('open-menu')
    },
    async inicializar() {
      await this.inicializarCatalogos()
      await Api.wait(250)
      await this.obtener()
      return true
    },
    async inicializarCatalogos() {
      this.empresa = (await Api.get('empresa'))[0]
      this.clientes = (await Api.get('cliente'))
        .filter(c => c.nombre && c.nombre != '')
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      this.usuarios = (await Api.get('directorio'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      this.brandings = (await Api.get('branding'))
        .sort((a, b) => a.alias > b.alias ? 1 : -1)
      this.equipos = (await Api.get('equipo'))
        .sort((a, b) => a.alias > b.alias ? 1 : -1)
        .map(a => {
          if (!a.alias && a.sn)
            a.alias = a.sn
          a.alias = (a.alias || '') + ' ' + a.marca + ' ' + a.modelo
          return a
        })
      let tiposOrdenesServicio = ['Garantía', 'Preventivo', 'Correctivo', 'Diagnóstico', 'Reparación', 'Capacitación', 'Instalación', 'Otros']
      for (let i in this.campos) {
        if (this.campos[i].name == 'idCliente')
          this.campos[i].options = this.clientes
        if (this.campos[i].name == 'idBranding')
          this.campos[i].options = this.brandings
        if (this.campos[i].name == 'idEquipo')
          this.campos[i].options = JSON.parse(JSON.stringify(this.equipos))
        if (this.campos[i].name == 'tipoOrdenServicio')
          this.campos[i].options = tiposOrdenesServicio
          .map(o => {
            return {
              nombre: o,
              _id: o
            }
          })
      }
      await Api.wait(100)
      return true
    },
    async obtener() {
      this.cargando = true
      if (this.id && this.id.length > 1) {
        let orden = await Api.get('ordenservicio', this.id, true)
        if (orden.idEquipo)
          for (let e of this.equipos)
            if (e._id == orden.idEquipo)
              orden.equipo = e
        this.orden = orden
        console.log("Orden?", JSON.stringify(this.orden).length, this.orden)
        if (this.orden.idBranding && this.orden.idBranding != '') {
          await Api.wait(200)
          this.orden.branding = await Api.get('branding', this.orden.idBranding)
          console.log("Branding", this.orden.branding)
        }
        this.proyectos = (await Api.find('proyectoorden', ['idCliente,eq,' + this.orden.idCliente]))
          .filter(p => p.activo)
        this.eventos = await Api.find('bitacora', ['idOrdenservicio,eq,' + this.orden._id], {
          subset: [{
            coleccion: 'directorio',
            alias: 'autor',
            query: '_id,eq,',
            sustituir: 'idAutor',
            unico: true
          }],
          sort: ['fecha,-1']
        })
      }
      await Api.wait(200)
      this.editable = !(this.orden && this.orden._id)
      this.cargando = false
      this.$forceUpdate()
      return Promise.resolve(true)
    },
    async setModo(val) {
      if (this.cargando) {
        toast("Aún cargando", null, 'medium')
      } else {
        this.modo = ''
        await Api.wait(50)
        this.modo = val
        console.log("setModo", val)
        this.$forceUpdate()
        if (val == 'acciones') {
          await Api.wait(100)
          this.cargando = true
          if (!this.esMovil) {
            try {
              await this.obtenerPlantilla()
              await this.verPDF()
            } catch (e) {
              console.error("Error al cargar PDF:", e.message || e)
              toast("No se pudo cargar el PDF: " + (e.message || "Error desconocido"))
            }
          }
          this.cargando = false
          this.$forceUpdate()
        }
      }
    },
    nombreDelEquipo() {
      let nombre = '(Sin equipo)'
      if (this.orden.equipo && this.orden.equipo._id) {
        if (this.orden.equipo.alias)
          nombre = this.orden.equipo.alias
        else {
          nombre = ''
          let props = ['tipo', 'marca', 'modelo', 'sn']
          for (let prop of props)
            if (this.orden.equipo[prop])
              nombre += this.orden.equipo[prop] + ' '
        }
      }
      console.log("nombreDelEquipo", this.orden.equipo, this.orden.idEquipo, nombre)
      return nombre
    },
    set(campo, valor) {
      this.orden[campo] = valor
      console.log("Set", campo, valor)
      if (campo == 'idCliente') {
        let cliente = {}
        for (let cl of this.clientes)
          if (cl._id == valor && cl.idBranding) {
            console.log("Cliente", cl.nombre || cl.alias, cl)
            this.set('idBranding', cl.idBranding)
            if (!(this.orden.solicitante && this.orden.solicitante != ''))
              this.set('solicitante', cl.representante || '')
          }
        for (let i in this.campos)
          if (this.campos[i].name == 'idEquipo') this.campos[i].options = this.equipos.filter(e => e.idCliente == valor)
        this.$forceUpdate()
      }
      if (campo == 'terminada' && valor == true) {
        this.orden.fechaTerminada = (valor == true) ? new Date().getTime() : null
        if (this.orden.fechaTerminada)
          toast("Orden terminada el " + this.$options.filters.moment(this.orden.fechaTerminada, 'MMM DD HH:mm'))
      }
    },
    async seleccionarEquipo() {
      let vm = this
      let equipos = this.equipos.filter(e => e.idCliente == vm.orden.idCliente)
      let cliente = this.clientes.filter(c => c._id == vm.orden.idCliente)[0]
      let id = 'seleccionarEquipo'
      console.log("ModalSeleccionarEquipo", equipos)
      if (this.orden.idCliente == '')
        alert("Debe seleccionar un cliente primero")
      else if (!this.editable)
        console.log("LOL no hago nada")
      else
        return this.$ionic.modalController
          .create({
            component: ModalSeleccionarEquipo,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                equipos,
                cliente
              }
            }
          })
          .then(m => {
            vm.modals[id] = m
            console.log("ModalSeleccionarEquipo", vm.modal)
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("Modal cerrado")
              Api.$off('ModalSeleccionarEquipoCerrar')
              Api.$off('seleccionarEquipo')
            })
            Api.$on('ModalSeleccionarEquipoCerrar', _ => {
              console.log("$on modalCerrar")
              vm.modals[id].dismiss()
            })
            Api.$on('seleccionarEquipo', equipo => {
              vm.orden.idEquipo = equipo._id
              vm.orden.equipo = equipo
              toast("Equipo seleccionado: " + equipo.sn)
              vm.$forceUpdate()
              console.log("$on seleccionarEquipo", equipo.sn, equipo)
              vm.modals[id].dismiss()
            })
          })
    },
    async seleccionarCliente() {
      let vm = this
      let clientes = this.clientes
      let id = 'seleccionarCliente'
      console.log("ModalSeleccionarCliente", clientes)
      if (!this.editable)
        console.log("seleccionarCliente LOL no hago nada")
      else
        return this.$ionic.modalController
          .create({
            component: ModalSeleccionarCliente,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                clientes
              }
            }
          })
          .then(m => {
            vm.modals[id] = m
            console.log("ModalSeleccionarCliente", vm.modals[id])
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("seleccionarCliente Modal cerrado")
              Api.$off('ModalSeleccionarClienteCerrar')
              Api.$off('seleccionarCliente')
            })
            Api.$on('ModalSeleccionarClienteCerrar', _ => {
              console.log("$on ModalSeleccionarClienteCerrar")
              vm.modals[id].dismiss()
            })
            Api.$on('seleccionarCliente', async c => {
              //vm.orden.idCliente = c._id
              vm.set('idCliente', c._id)
              vm.orden.cliente = c
              vm.proyectos = (await Api.find('proyectoorden', ['idCliente,eq,' + c._id]))
                .filter(p => p.activo)
              toast("Cliente seleccionado: " + c.nombre)
              vm.$forceUpdate()
              console.log("$on seleccionarCliente", c.nombre)
              vm.modals[id].dismiss()
            })
          })
    },
    toggleEditar() {
      this.editable = !this.editable
      if (this.editable == true) {
        Api.save('bitacora', {
          idAutor: this.yo._id,
          fecha: new Date().getTime(),
          mensaje: 'Usuario ha activado la edición de la Orden de servicio',
          idOrdenservicio: this.orden._id
        })
      }
    },
    async subirImagen() {
      this.cargando = true
      try {
        let imagen = await Api.upload('#img')
        if (!this.orden.imagenes)
          this.orden.imagenes = []
        let descripcion = prompt('Descripción de la imagen (opcional)', 'Imagen ' + (this.orden.imagenes.length + 1))
        this.orden.imagenes.push({
          imagen,
          descripcion
        })
        let noRedirigir = true
        this.guardar(noRedirigir)
      } catch (e) {
        console.error("EIMAGEN", e)
        toast("No se pudo subir la imagen")
      }
      this.cargando = false
    },
    eliminarImagen(indice) {
      let imagenes = []
      for (let i in this.orden.imagenes)
        if (i != indice)
          imagenes.push(this.orden.imagenes[i])
      this.orden.imagenes = imagenes
      let noRedirigir = true
      this.guardar(noRedirigir)
      this.$forceUpdate()
    },
    agregarCosto() {
      if (!this.orden.costos)
        this.orden.costos = []
      this.orden.costos.push({
        cantidad: 1,
        descripcion: ' ',
        precioUnitario: 1
      })
      console.log("agregarCosto", this.orden.costos)
      this.$forceUpdate()
    },
    async asignarFolio() {
      let ultimoFolio = 0
      try {
        ultimoFolio = (await Api.find('ordenservicio', [], {
          sort: ['folio,-1'],
          limit: 1,
        }))
        console.log("ultimoFolio encontrado?", ultimoFolio)
        ultimoFolio = ultimoFolio[0].folio || 0
        ultimoFolio = parseFloat(ultimoFolio)
        console.log("ultimoFolio encontrado?", ultimoFolio)
      } catch (e) {}
      ultimoFolio++
      this.orden.folio = ultimoFolio
      toast("Asignado folio: " + this.orden.folio)
      await Api.wait(100)
      return Promise.resolve(true)
    },
    async guardar(noRedirigir) {
      noRedirigir = noRedirigir && true
      let camposFaltantes = []
      for (let campo of ['idCliente', 'idEquipo', 'idBranding', 'fechaCreada', 'tipoOrdenServicio', 'fallaReportada', 'tiposIncidente'])
        if (!(this.orden[campo] && this.orden[campo] != ''))
          camposFaltantes.push(campo)
      this.orden.costos = this.orden.costos.filter(c => parseFloat(c.cantidad || 0) != 0)
      if (camposFaltantes.length == 0) {
        this.cargando = true
        this.orden.fechaModificacion = new Date().getTime()
        this.orden.idUsuarioUltimaModificacion = this.yo._id
        if (this.orden.terminada && !this.orden.fechaTerminada)
          this.orden.fechaTerminada = new Date().getTime()
        if (typeof this.orden.fecha != 'number')
          this.orden.fecha = new Date(this.orden.fecha).getTime()
        if (!(this.orden.folio && this.orden.folio != '')) {
          await this.asignarFolio()
        }
        let u = await Api.save('ordenservicio', this.orden)
        if (Api.modoProduccion)
          toast("Guardado")
        await Api.wait(100)
        if (!this.orden._id) {
          this.orden._id = u._id
          this.orden.branding = await Api.get('branding', this.orden.idBranding)
        }
        try {
          await Api.delete('ordenserviciopdf', this.orden._id)
        } catch (e) {}
        if (!noRedirigir)
          this.$router.push('/ordenes')
      } else {
        alert("Faltan campos: " + camposFaltantes.join(', '))
      }
      this.cargando = false
    },
    async obtenerPlantilla() {
      let vm = this
      let idBranding = this.orden.idBranding
      console.log("obtenerPlantilla branding?", idBranding)

      // Verificar que exista idBranding
      if (!(vm.orden && vm.orden.idBranding)) {
        console.error("No hay idBranding en la orden")
        throw new Error("No hay branding configurado para esta orden")
      }

      try {
        // Obtener el branding si no está cargado
        let branding = vm.orden.branding
        if (!branding || !branding._id) {
          console.log("Cargando branding desde API...")
          branding = await Api.get('branding', idBranding)
          vm.orden.branding = branding
        }

        // Verificar que el branding tenga plantilla configurada
        if (!branding || !branding.plantilladocx) {
          throw new Error("El branding no tiene plantilla configurada")
        }

        // Si plantilladocx ya es un string largo (la plantilla real), ya está cargada
        if (typeof branding.plantilladocx === 'string' && branding.plantilladocx.length > 100) {
          console.log("Plantilla ya cargada, longitud:", branding.plantilladocx.length)
          return true
        }

        // Cargar la plantilla desde brandingplantilladocx
        console.log("Cargando plantilla desde brandingplantilladocx, id:", branding._id)
        let anularTimeout = true
        let plantillaObj = await Api.get('brandingplantilladocx', branding._id, anularTimeout)

        if (!plantillaObj || !plantillaObj.data) {
          throw new Error("No se encontró la plantilla en la base de datos")
        }

        console.log("Plantilla recuperada, longitud:", plantillaObj.data.length)
        branding.plantilladocx = plantillaObj.data
        vm.orden.branding = branding

        return true
      } catch (e) {
        console.error("EPLANTILLA", e)
        throw e
      }
    },
    async crearPDF() {
      let url = 'http://www.africau.edu/images/default/sample.pdf'
      let vm = this
      if (!this.orden.folio)
        await this.asignarFolio()
      return new Promise(async (resolve, reject) => {
        try {
          // Verificar que la plantilla esté cargada correctamente
          let plantilladocx = this.orden.branding ? this.orden.branding.plantilladocx : null

          // Si no hay plantilla o es un booleano, intentar cargarla
          if (!plantilladocx || typeof plantilladocx !== 'string' || plantilladocx.length < 100) {
            console.log("Plantilla no cargada o inválida, intentando obtenerla...")
            console.log("plantilladocx tipo:", typeof plantilladocx, "valor:", plantilladocx)
            try {
              await vm.obtenerPlantilla()
              plantilladocx = vm.orden.branding ? vm.orden.branding.plantilladocx : null
              console.log("Plantilla obtenida, longitud:", plantilladocx ? plantilladocx.length : 0)
            } catch (e) {
              console.error("No se pudo obtener la plantilla:", e.message || e)
              toast("Error: " + (e.message || "No se pudo obtener la plantilla"))
              reject(e)
              return
            }
          }

          // Verificar nuevamente que la plantilla sea válida
          if (!plantilladocx || typeof plantilladocx !== 'string' || plantilladocx.length < 100) {
            let error = new Error("La plantilla no está disponible o es inválida")
            console.error("Plantilla inválida después de intentar cargarla")
            toast("Error: La plantilla del documento no está disponible")
            reject(error)
            return
          }

          console.log("Generando PDF con plantilla de", plantilladocx.length, "caracteres")
          let orden = JSON.parse(JSON.stringify(this.orden))
          if (typeof orden.fechaCreada != 'number')
            orden.fechaCreada = new Date(orden.fechaCreada).getTime()
          for (let prop in orden) {
            if (prop.startsWith('fecha'))
              orden[prop] = this.$options.filters.moment(orden[prop], 'YYYY-MM-DD HH:mm')
            if (!isNaN(orden[prop]) && prop != 'folio')
              orden[prop] = this.$options.filters.currency(orden[prop], '')
          }
          if (!orden.equipo && orden.idEquipo && orden.idEquipo != '')
            orden.equipo = await Api.get('equipo', orden.idEquipo)

          // Obtener autor (puede no existir si fue eliminado)
          try {
            orden.autor = await Api.get('directorio', orden.idAutor)
          } catch (e) {
            console.warn("Autor no encontrado:", orden.idAutor)
            orden.autor = { nombre: '(Usuario eliminado)', email: '' }
          }

          // Obtener cliente
          try {
            orden.cliente = await Api.get('cliente', orden.idCliente)
          } catch (e) {
            console.warn("Cliente no encontrado:", orden.idCliente)
            orden.cliente = { nombre: '(Cliente no disponible)', email: '', telefono: '' }
          }
          // Enmascarar los datos no existentes
          for (let campo of vm.soap)
            if (!orden[campo.name])
              orden[campo.name] = ''
          for (let campo of ['alias', 'nombre', 'marca', 'modelo', 'sn'])
            if (!orden.equipo[campo])
              orden.equipo[campo] = ''
          for (let campo of ['alias', 'telefono', 'telefonos', 'email', 'rfc', 'direccion', 'representante'])
            if (!orden.cliente[campo])
              orden.cliente[campo] = ''
          // Enmascarar los costos no existentes
          console.log("Enmascarando costos", orden.costos.length, orden.costos)
          if (orden.costos.length == 0 || typeof orden.costos != 'object') {
            orden.costos = [{
              cantidad: '',
              concepto: 'Ninguna',
              precioUnitario: ''
            }]
          }
          //
          console.log("crearPDF?", orden)
          let docx = await Docxgen.docxSimple(orden, plantilladocx, true)
          url = 'data:application/pdf;base64,' + (await Api.libreofficetopdf(docx)).data.data
          console.log("docx?", docx.length, url.length)
          await Api.save('ordenserviciopdf', {
            _id: orden._id,
            data: url
          })
          resolve(url)
        } catch (e) {
          toast("No se pudo obtener el PDF")
          console.error("EPDF", e)
          if (this.reintentosPDF > 0) {
            this.reintentosPDF--
            toast("Reintentando generar PDF")
            await Api.wait(1000)
            return this.crearPDF()
          } else
            reject(e)
        }
      })
    },
    async verPDF() {
      let url = ''
      try {
        let s = await Api.get('ordenserviciopdf', this.orden._id)
        url = s.data
        toast("PDF recuperado")
      } catch (e) {
        url = await this.crearPDF()
      }
      if (Api.esMovil())
        window.open(url, '_blank')
      else
        this.pdfUrl = url
      return this.pdfUrl
    },
    async enviar() {
      toast("Cargando")
      let destino = prompt("Introduzca la dirección de correo", ((this.orden).cliente || {}).email)
      let mc = (this.orden.branding || {}).mailConfig
      console.log("mailConfig?", mc)
      let titulo = 'Orden de servicio ' + this.orden.folio
      let pdfUrl = await this.verPDF()
      //toast("Por implementar")
      try {
        let em = {
          destino,
          titulo,
          cuerpo1: 'Buen día. Adjunto la orden de servicio solicitada. ',
          cuerpo2: 'Para cualquier aclaración, por favor, <a href="' + this.yo.email + '">Envíenos un correo.</a> y lo atenderemos a la brevedad.',
          attachments: [{
            filename: 'OS' + this.orden.folio + '.pdf',
            content: pdfUrl.split(',')[1],
            encoding: 'base64'
          }],
          mailconfig: {
            host: mc.host,
            port: mc.port,
            secure: true,
            auth: {
              type: 'basic',
              user: mc.user,
              pass: mc.pw
            }
          }
        }
        console.log("Enviando?", em)
        toast("Enviando correo")
        let u = await Emailer.enviar(em)
        console.log("enviado", u)
        alert("Correo enviado")
      } catch (e) {
        alert("No se pudo enviar el correo")
        console.error("EEMAIL", e)
      }
      console.log("acciones", destino)
    },
    accion(a) {
      switch (a) {
        case 'PDF':
        default:
          this.verPDF();
          break;
        case 'Enviar':
          this.enviar();
          break;
        case 'Historial de equipo':
          window.open('#/catalogos/equipos/' + this.orden.idEquipo + '/modo/historial', '_blank');
          break;
        case 'Custodia':
          window.open('#/catalogos/equipos/' + this.orden.idEquipo + '/modo/custodia', '_blank');
          break;
        case 'Cita tentativa':
          this.modalCitaTentativa();
          break;
        case 'Cancelar':
          if (this.yo.permiso_creaOrdenesServicio)
            this.cancelar();
          else
            alert("No cuenta con los permisos necesarios")
          break;
      }
    },
    async modalCitaTentativa() {
      let id = 'modalCitaTentativa'
      let vm = this
      return this.$ionic.modalController
        .create({
          component: modalCitaTentativa,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              esModal: true,
              modalIdEquipo: this.orden.idEquipo
            }
          }
        })
        .then(m => {
          vm.modals[id] = m
          vm.modals[id].present()
          vm.modals[id].onDidDismiss(_ => {
            console.log("modalCitaTentativa cerrado")
          })
          Api.$on('cerrarModalCita', citaCreada => {
            vm.modals[id].dismiss()
            if (citaCreada == true)
              toast("Cita creada")
            else
              toast("Proceso cancelado")
          })
        })
    },
    volver() {
      this.$router.push('/ordenes')
    },
    cancelar() {
      if (true == confirm('Desea cancelar esta Orden de servicio?\nEsto no se puede deshacer')) {
        this.set('cancelada', !this.orden.cancelada)
        if (this.orden.cancelada == true)
          this.set('fechaCancelacion', new Date().getTime())
        this.guardar()
        alert("Orden cancelada")
        this.$router.push('/ordenes')
      }
    },
    // Catalogos moviles
    async nuevoCliente() {
      toast("Nuevo cliente")
      let vm = this
      let id = 'nuevoCliente' + Math.random()
      if (!vm.modals[id])
        return this.$ionic.modalController
          .create({
            component: CatalogoCliente,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                esModal: true
              }
            }
          })
          .then(m => {
            vm.modals[id] = m
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("modal nuevoCliente cerrado")
            })
            Api.$on('nuevoClienteCreado', async idNuevoCliente => {
              vm.modals[id].dismiss()
              toast("Recreando catálogos")
              await Api.wait()
              await vm.inicializarCatalogos()
              await Api.wait(100)
              vm.orden.idCliente = idNuevoCliente
              vm.$forceUpdate()
            })
            Api.$on('cerrarModal', _ => {
              vm.modals[id].dismiss()
            })
          })
      else return 0
    },
    async nuevoEquipo() {
      toast("Nuevo equipo")
      let vm = this
      let id = 'nuevoEquipo' + Math.random()
      if (!vm.modals[id])
        return this.$ionic.modalController
          .create({
            component: CatalogoEquipo,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                esModal: true,
                idClienteEquipoNuevo: vm.orden.idCliente
              }
            }
          })
          .then(m => {
            console.log("ModalSeleccionarEquipo", id)
            vm.modals[id] = m
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("modal nuevoEquipo cerrado")
            })
            Api.$on('nuevoEquipoCreado', async nuevoEquipo => {
              console.log("$on nuevoEquipoCreado", nuevoEquipo)
              vm.modals[id].dismiss()
              vm.ocultarCampoEquipo = true
              toast("Recreando catálogos")
              await Api.wait()
              await vm.inicializarCatalogos()
              vm.orden.idEquipo = nuevoEquipo._id
              vm.orden.equipo = nuevoEquipo
              await Api.wait(100)
              vm.ocultarCampoEquipo = false
              vm.$forceUpdate()
            })
            Api.$on('cerrarModal', _ => {
              vm.modals[id].dismiss()
            })
          })
      else return 0
    },
    accionDesdeForm(str) {
      console.log("$ accion", str)
      this[str]()
    }
  }
}
</script>
